import { atom, selector } from "recoil";

export type innerType = {
  defaultOrder: string;
  notFoundPage: boolean;
  reactDOMLoaded: boolean;
  recentRefresh: boolean;
};

export const innerState = atom<innerType>({
  key: "innerState",
  default: {
    notFoundPage: false,
    defaultOrder: "",
    reactDOMLoaded: false,
    recentRefresh: false,
  },
});

export const recentRefreshState = selector({
  key: "recentRefreshState",
  get: ({ get }) => {
    const originState = get(innerState);

    return originState.recentRefresh;
  },
});
